/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Spin,
  Col,
  Modal,
  Input,
  DatePicker,
  message,
} from 'antd';
import Table from 'components/Table';
import { onError } from 'utils/handlers';
import PercentageInput from 'components/PercentageInput';
import percentFormatter from 'utils/percentFormatter';
import FormSubmitControls from 'components/FormSubmitControls';
import { formatReceived } from 'utils/formatValues';
import { getEstadosGlobales } from 'api/catalogos';
import { getTiposDeDepositos } from 'api/catalogos/tiposDeDepositos';
import { getBancos } from 'api/configuraciones/bancos';
import {
  getBeneficiariosExternos,
  postBeneficiarioExterno,
  patchBeneficiarioExterno,
  deleteBeneficiarioExterno,
  getBeneficiarioExterno,
} from 'api/nominas/descuentos/beneficiariosExternos';
import Select from 'components/Select';
import ModalDelete from 'components/ModalDelete';
import { getMetodosDePagos } from 'api/catalogos/metodosDePagos';
import { FLOAT_NUMER_PATTERN } from 'utils/patterns';
import { ESTATUS_ACTIVO, ESTATUS_INACTIVO } from 'utils/constants';
import { getDocumentosEmpleadosParams } from 'api/catalogos/documentosEmpleados';
import FormItem from 'antd/es/form/FormItem';
import Previewer from 'components/Previewer';
import API from 'utils/api';
import { getTiposDeDocumentos } from 'api/catalogos/tiposDeDocumentos';
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import Uploader from 'components/Uploader';
import moment from 'moment';
import {
  deleteDocumentoIncidenciaEmpleado,
  getDocumentoIncidenciaEmpleado,
  getDocumentosIncidenciasEmpleados,
  patchDocumentoIncidenciaEmpleado,
  postDocumentoIncidenciaEmpleado,
} from 'api/nominas/incidencias/IncidenciasEmpleadosAdjuntos';

export const adjuntosIncidenciaPermission = {
  permissionModel: 'incidenciaempleadoadjunto',
  catalogsModels: [],
  tabsModels: [],
};

const AdjuntosIncidencias = ({
  permissions,
  selected,
  disable,
  isBlocked,
}) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [data, setData] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visibleAlert, setVisibleAlert] = useState();
  const [estados, setEstados] = useState([]);
  const [esTransferencia, setEsTransferencia] = useState(false);
  const [esClabe, setEsClabe] = useState(false);
  const [tipoDeDocumento, setTipoDeDocumento] = useState();
  const [formFormaPago] = Form.useForm();
  const [porcentajes, setPorcentajes] = useState(0);
  const [editable, setEditable] = useState(false);
  const [porcentajeSeleccionado, setPorcentajeSeleccionado] = useState(0);
  const [dataFiltered, setDataFiltered] = useState([]);
  const [currentFile, setCurrentFile] = useState();
  const [visiblePreview, setVisiblePreview] = useState(false);
  const [tiposDeDocumentos, setTiposDeDocumentos] = useState([]);
  const [pageActual, setPageActual] = useState(1);

  const formInstances = [
    form,
    formDatos,
    formFormaPago,
  ];

  // const fetchData = async () => {
  //   setLoading(true);
  //   const _data = await getDocumentosPercepciones({ incidencia_empleado: selected });
  //   setData(formatReceived(_data));
  //   setLoading(false);
  //   return _data;
  // };

  const getFechaServidor = async () => ({ fecha: new Date().toISOString() });

  const obtenerFechaServidorYSetear = async () => {
    try {
      const { fecha } = await getFechaServidor(); // retorna string tipo "2025-06-24T18:15:00Z"
      form.setFieldsValue({
        fecha_de_carga: moment(fecha), // ⬅️ convertir string ISO a moment
      });
    } catch (err) {
      message.error('No se pudo obtener la fecha del servidor');
    }
  };

  const fetchData = async (page = 1, q = {}) => {
    setLoading(true);
    const _data = await getDocumentosIncidenciasEmpleados({
      page,
      ...q,
      incidencia_empleado: selected,
    });
    setData(formatReceived(_data));
    setLoading(false);
  };
  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);
      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await getDocumentosIncidenciasEmpleados({
        page: cleanPage,
        ...q,
        incidencia_empleado: selected,
      });

      const { results } = _data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ..._data, results: [...results] });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  useEffect(() => {
    let mounted = true;

    if (!selected) {
      // Limpiar: sin un incidencia_empleado padre no hay nada que mostrar.
      // Evita que al Agregar un nuevo registro (o al cambiar de registro)
      // se sigan mostrando los documentos del registro editado anteriormente.
      setData({ results: [], count: 0 });
      setSelectedRowKeys([]);
      setPageActual(1);
      return undefined;
    }

    const fetchAll = async () => {
      setLoading(true);
      const [
        _estados,
        _tiposDeDocumentos,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getTiposDeDocumentos(),
        getDocumentosIncidenciasEmpleados({ incidencia_empleado: selected }),
      ]);
      const { results } = _data;
      if (mounted) {
        setEstados(_estados);
        setTiposDeDocumentos(_tiposDeDocumentos);
        setData({ ..._data, results });
        setSelectedRowKeys([]);
        setPageActual(1);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, [selected]);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    setEsTransferencia(false);
    setEditable(false);
    setEsClabe(false);
    form.resetFields();
    formDatos.resetFields();
  };

  const onClickAdd = async () => {
    onCancel();
    setVisible(true);
    await obtenerFechaServidorYSetear();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setEditable(true);

    const [key] = selectedRowKeys;
    const match = responseData || data?.results?.find((item) => item.id === key);

    try {
      const documento = await getDocumentoIncidenciaEmpleado(match.id);

      // Convertir fecha correctamente
      if (documento.fecha_de_carga && typeof documento.fecha_de_carga === 'string') {
        documento.fecha_de_carga = moment(documento.fecha_de_carga);
      }

      // Cargar en formularios
      form.setFieldsValue(formatReceived(documento));
      formDatos.setFieldsValue(formatReceived(documento));

      setVisible(true);
    } catch (error) {
      message.error('Error al cargar el documento.');
    }

    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();

      const rawValues = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };

      // Asegurar campo obligatorio
      rawValues.incidencia_empleado = selected;

      const formData = new FormData();
      Object.entries(rawValues).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (key === 'archivo' && value instanceof File) {
            formData.append(key, value);
          } else if (moment.isMoment(value)) {
            formData.append(key, value.format('YYYY-MM-DD'));
          } else {
            formData.append(key, value);
          }
        }
      });

      const [key] = selectedRowKeys;
      const saved = key
        ? await patchDocumentoIncidenciaEmpleado(key, formData)
        : await postDocumentoIncidenciaEmpleado(formData);

      if (saved) {
        if (_continue) {
          await fetchData(pageActual);
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData(pageActual);
        }
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteDocumentoIncidenciaEmpleado(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData(pageActual);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);

    const newRecord = {
      ...record,
      fecha_de_carga: record.fecha_de_carga ? moment(record.fecha_de_carga) : null,
    };

    form.setFieldsValue(newRecord);
  };

  const onClickDownload = () => {
    const clone = [...(data?.results || [])];
    const [key] = selectedRowKeys;
    const match = clone.find((e) => e.id === key);

    if (match?.archivo) {
      // Usar la URL completa proporcionada por la API
      const fileUrl = match.archivo;

      // Crear un enlace de descarga y simular un click
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = match.archivo.split('/').pop(); // Extrae el nombre del archivo de la URL
      link.click();
    }
  };

  const limitMB = 5;
  const allowedExtensions = ['jpg', 'png', 'jpeg', 'pdf'];

  const handleUploadChange = ({ file }) => {
    const realFile = file.originFileObj || file;

    if (!(realFile instanceof File)) {
      message.error('El archivo no es válido.');
      return;
    }

    const { name } = realFile;
    const extension = name.split('.').pop().toLowerCase();
    const baseName = name.replace(/\.[^/.]+$/, '');

    form.setFieldsValue({
      archivo: realFile,
      archivo_nombre: name,
      extension_del_documento: extension,
      nombre_de_documento: baseName,
    });
  };

  const esImagen = (file) => {
    if (!file || !file.archivo) return false; // Si no hay archivo, no es imagen
    const extensionRegex = /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i;
    const mimeTypeRegex = /^image\//;

    return mimeTypeRegex.test(file.type) || extensionRegex.test(file.archivo);
  };

  const getFileUrl = () => {
    if (!currentFile?.archivo) return null;
    if (currentFile.archivo.includes('?')) return currentFile.archivo;
    return `${currentFile.archivo}?t=${new Date().getTime()}`;
  };
  const fileUrl = getFileUrl();

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const columns = [
    {
      titleText: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 300,
    },
    {
      titleText: 'Fecha de Carga',
      dataIndex: 'fecha_de_carga',
      key: 'fecha_de_carga',
      width: 400,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Nombre De Documento',
      dataIndex: 'nombre_de_documento',
      key: 'nombre_de_documento',
      width: 300,
    },

    {
      titleText: 'Archivo',
      dataIndex: 'archivo_nombre',
      key: 'archivo_nombre',
      width: 300,
    },

    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data?.results || []}
          rowSelection={rowSelection}
          pagination={false}
          paginationCallback={fetchPaginated}
          count={data?.count || 0}
          currentPage={pageActual}
          allowExport
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          customActions={[
            {
              onClick: onClickDownload, // Cambiar aquí
              icon: <DownloadOutlined />,
              text: 'Descargar Documento', // Cambiar el texto a 'Descargar'
              disabled: !selectedRowKeys.length,
            },
          ]}
          allowDelete={!disable}
          permission={permissions}
          allowExportPDF={false}
          disableAdd={disable || isBlocked}
          disableDelete={isBlocked}
        />
        <Modal
          open={open}
          width={700}
          closable={false}
          maskClosable={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Documento para Incidencia Empleado`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disable && !isBlocked}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            name="general"
            disabled={disable || isBlocked}
          >
            <Col xs={24} sm={8}>
              <Form.Item
                name="fecha_de_carga"
                label="Fecha de Carga"
                hasFeedback
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="nombre_de_documento"
                label="Nombre de Documento"
              >
                <Input disabled />
              </Form.Item>

            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="archivo_nombre"
                label="Nombre del archivo"

              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="extension_del_documento"
                label="extension"
              >
                <Input disabled />

              </Form.Item>
            </Col>

            <Form.Item
              name="archivo"
              valuePropName="file"

            >
              <Uploader
                title="Documento"
                limitMB={limitMB}
                allowedExtensions={allowedExtensions}
                allowPreview={false}
                onChange={handleUploadChange}
              />
            </Form.Item>
          </Form>
        </Modal>
        <Previewer
          open={visiblePreview}
          setVisible={setVisiblePreview}
          iFrameUrl={fileUrl}
          isImage={esImagen(currentFile)}
        />

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Documento para Incidencia Empleado ${form.getFieldValue('archivo_nombre')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};
export default AdjuntosIncidencias;
